import { useState } from "#app";
import type {
  DehydratedState,
  VueQueryPluginOptions,
} from "@tanstack/vue-query";
import {
  dehydrate,
  hydrate,
  QueryClient,
  VueQueryPlugin,
} from "@tanstack/vue-query";

// Plugin based on the docs here https://tanstack.com/query/v4/docs/vue/guides/ssr
// Modify your Vue Query global settings here
export default defineNuxtPlugin({
  name: "vueQuery",
  setup: (nuxt) => {
    const vueQueryState = useState<DehydratedState | null>("vue-query");
    const queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          staleTime: 1000 * 15,
          enabled: ({ options }) => {
            if (
              import.meta.server &&
              "suspense" in options &&
              options.suspense
            ) {
              return true;
            }

            return !!import.meta.client;
          },
        },
      },
    });
    const options: VueQueryPluginOptions = { queryClient };

    nuxt.vueApp.use(VueQueryPlugin, options);

    if (import.meta.server) {
      nuxt.hooks.hook("app:rendered", () => {
        vueQueryState.value = dehydrate(queryClient);
      });
    }

    if (import.meta.client) {
      hydrate(queryClient, vueQueryState.value);
    }
  },
});
